import { IImportModel } from '../importer/model';

export const ancillaryTransfersImportDomainSelector = (state: any): IImportModel =>
  state.ancillaryTransfersImport as IImportModel;
